import { path as parentPath } from "../init";

export const path = `${parentPath}/sources`;

export const apiUrls = {
  list: "/api/specials/sources",
  source_prompt: "/api/specials/sources/prompt",
  positions: "/api/specials/sources/positions",
  info: "/api/specials/sources/source_{sourceId}",
  start: "/api/specials/sources/source_{sourceId}/start",
};

export const infoLink = (source) => {
  return `${path}/source_${source._id}`;
};

export const formLink = (schedule) => {
  return `${infoLink(schedule)}/form`;
};
